// extracted by mini-css-extract-plugin
export default {"xIconWrapper":"XIconWrapper_xIconWrapper__i8ahP"};